import * as React from 'react'
import moment from 'moment'

import { useTimelineData } from '../context/DataContext'
import { RestPartBlock } from '../blocks/RestPartBlock'
import { RestReducedPartBlock } from '../blocks/RestReducedPartBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const RestPartsLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { weeklyRests, weeklyReducedRests } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {weeklyRests
        .filter((r) => moment(r.endTime).toDate().getFullYear() != 9999)
        .map((weeklyRest, index) => (
          <RestPartBlock key={index} weeklyRest={weeklyRest} index={index} />
        ))}
      {weeklyReducedRests
        .filter((r) => moment(r.endTime).toDate().getFullYear() != 9999)
        .map((weeklyReducedRest, index) => (
          <RestReducedPartBlock
            key={index}
            weeklyReducedRest={weeklyReducedRest}
            index={index}
          />
        ))}
    </LayerWrapper>
  )
}

export default RestPartsLayer
